var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6094 14.1172C9.97656 14.1172 9.44141 13.9863 9.00391 13.7246C8.57031 13.459 8.24219 13.082 8.01953 12.5938C7.80078 12.1016 7.69141 11.5195 7.69141 10.8477C7.69141 10.1484 7.81836 9.55078 8.07227 9.05469C8.32617 8.55469 8.68359 8.17188 9.14453 7.90625C9.60547 7.64062 10.1465 7.50781 10.7676 7.50781C11.0723 7.50781 11.3555 7.53516 11.6172 7.58984C11.8789 7.64453 12.1152 7.7207 12.3262 7.81836L12.168 8.33984C11.9492 8.24219 11.7168 8.16797 11.4707 8.11719C11.2246 8.06641 10.9883 8.04102 10.7617 8.04102C10.2383 8.04102 9.79297 8.15625 9.42578 8.38672C9.0625 8.61328 8.7832 8.9375 8.58789 9.35938C8.39648 9.77734 8.30078 10.2715 8.30078 10.8418C8.30078 11.377 8.38281 11.8516 8.54688 12.2656C8.71094 12.6758 8.96289 13 9.30273 13.2383C9.64258 13.4727 10.0781 13.5898 10.6094 13.5898C10.918 13.5898 11.2109 13.5586 11.4883 13.4961C11.7695 13.4336 12.0254 13.3535 12.2559 13.2559V13.7949C12.0488 13.8887 11.8086 13.9648 11.5352 14.0234C11.2656 14.0859 10.957 14.1172 10.6094 14.1172Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyRight);
export default __webpack_public_path__ + "static/media/copyRight.04562cde9effb4b60f8a4f51360f91ce.svg";
export { ForwardRef as ReactComponent };